import React from 'react';
import { AdditionalPrivilegeItem } from '../PrivilegeConfig.types';
import { AdditionalPrivilegeTreeNode } from './AdditionalPrivilegeTreeNode';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type AdditionalPrivilegeTreeProps = {
  privilegeItems: AdditionalPrivilegeItem[];
  parentAdditionalPrivilegeLabels: string[];
};

export function AdditionalPrivilegeTree({
  privilegeItems,
  parentAdditionalPrivilegeLabels,
}: AdditionalPrivilegeTreeProps) {
  const { t } = useSonTranslation('PrivilegeConfig');

  if (!privilegeItems || privilegeItems.length === 0) {
    return null;
  }

  // enrich the items with the translated privilege name, so the sub(list) can be sorted alphabetically:
  const sortedPrivilegesWithLabel = privilegeItems
    .map(privilegeItem => ({
      ...privilegeItem,
      label: t(`headline.${privilegeItem.privilegeType.toLowerCase()}` as any),
    }))
    .toSorted((a, b) => a.label.localeCompare(b.label));

  return (
    <ul className="privilege-config__additional-privilege-tree-list">
      {sortedPrivilegesWithLabel.map(privilegeItem => (
        <li className="privilege-config__additional-privilege-tree-list-item" key={privilegeItem.privilegeType}>
          <AdditionalPrivilegeTreeNode
            key={privilegeItem.privilegeType}
            privilegeItem={privilegeItem}
            parentAdditionalPrivilegeLabels={parentAdditionalPrivilegeLabels}
          />
        </li>
      ))}
    </ul>
  );
}
